import React, { createContext, useState, useContext, useEffect } from "react";
import LocalizedStrings from "react-localization";

// Dil seçeneklerini burada tanımlayın
const translations = {
  en: {
    home: "Home",
    about: "About",
    skills: "Skills",
    projects: "Projects",
    contact: "Contact",
    language: "English",
    switchLanguage: "Türkçe",
    //Hello Component 
    hello: "Hello",
    myNameIs: "My name is",
    fullName: "OMER YUSUF ELMALI",
    //About Component
    aboutMe: "About Me",
    personalInfoTitle: "Personal Info",
    experienceTitle: "Experience",
    educationTitle: "Education",
    hobbiesTitle: "Hobbies",
    personalInfo: "I am a Computer Engineering graduate with a passion for Data Engineering and Artificial Intelligence. My career goal is to specialize in these fields and continuously develop my skills in a dynamic and innovative environment. Currently, I am looking for a full-time position where I can grow and contribute to exciting projects. In the future, I aspire to become a lead developer in a team that creates cutting-edge products.",
    experience: "I have worked on various AI projects, including image segmentation, object detection, and deep learning-based models for mobile applications. Additionally, I have hands-on experience with TensorFlow, PyTorch, and deploying AI models in production environments.",
    education: "Bachelor's degree in Computer Engineering with a focus on network structures and Artificial Intelligence. During my studies, I specialized in network design, machine learning algorithms, and cloud infrastructure. I also worked on a drone stabilization project using deep reinforcement learning (DRL) for my thesis.",
    hobbies: "I enjoy running and pushing my physical limits. I’m passionate about exploring new technologies and cloud infrastructure, and I constantly work on personal projects to improve my programming and AI skills.",
    //Skills Component
    mySkills: "My Skills",
    python: "Python",
    pythonDesc: "General-purpose programming language",
    cpp: "C++",
    cppDesc: "System and performance programming",
    bashScript: "Bash Script",
    bashScriptDesc: "Linux shell scripting",
    sql: "SQL",
    sqlDesc: "Database query language",
    firebase: "Firebase",
    firebaseDesc: "Backend services & real-time database",
    react: "React",
    reactDesc: "Frontend framework for building UIs",
    tailwind: "Tailwind CSS",
    tailwindDesc: "Utility-first CSS framework",
    js: "JavaScript",
    jsDesc: "Programming language for web",
    tensorflow: "TensorFlow",
    tensorflowDesc: "AI & Machine Learning framework",
    pytorch: "PyTorch",
    pytorchDesc: "Deep learning & AI framework",
    opencv: "OpenCV",
    opencvDesc: "Computer vision library",
    pandas: "Pandas",
    pandasDesc: "Data analysis library",
    numpy: "NumPy",
    numpyDesc: "Scientific computing library",
    fastapi: "FastAPI",
    fastapiDesc: "Fast web framework for APIs",
    flask: "Flask",
    flaskDesc: "Lightweight web framework",
    scikit: "Scikit-Learn",
    scikitDesc: "Machine learning toolkit",
    git: "Git",
    gitDesc: "Version control system",
    docker: "Docker",
    dockerDesc: "Containerization platform",
    kubernetes: "Kubernetes",
    kubernetesDesc: "Container orchestration",
    linux: "Linux",
    linuxDesc: "Operating system & shell scripting",
    hadoop: "Apache Hadoop",
    hadoopDesc: "Big data processing framework",
    hive: "Apache Hive",
    hiveDesc: "Data warehouse system",
    sqoop: "Apache Sqoop",
    sqoopDesc: "Big data transfer tool",
    kafka: "Apache Kafka",
    kafkaDesc: "Distributed event streaming",
    sqlserver: "Microsoft SQL Server",
    sqlserverDesc: "Relational database system",
    unreal: "Unreal Engine 4",
    unrealDesc: "Game development engine",
    gazebo: "Gazebo",
    gazeboDesc: "Robotics simulation software",
    missionPlanner: "Mission Planner",
    missionPlannerDesc: "Autonomous drone software",
    //My Project Component
    myProjects: "My Projects",
    try: "Try",
    robustDrone: "ROBUST DRONE STABILIZATION SYSTEM",
    robustDroneDesc: "Quadcopter stabilization system using deep reinforcement learning algorithms in a simulated environment.",
    semanticClothes: "Semantic Segmentation On Clothes",
    semanticClothesDesc: "It should take a photo containing clothing as input, and then output the masked and cropped photo.",
    iso50001Chatbot: "ISO 50001 Information Robot",
    iso50001ChatbotDesc: "Artificial intelligence supported chatbot application that provides information about the energy management system. Provides information about ISO 50001.",
    //Personality Component
    personality: "Personality",
    personHead: "INTJ - Architect",
    headLetter: "Architects have superior abilities to think analytically, create long-term strategies, and combine deep technical knowledge in the software development process.",
    asASoftwareEngineer: "INTJ as a Software Engineer",
    asASoftwareEngineerLetter: "INTJs excel in software engineering because of their strategic thinking skills, problem-solving abilities, and strong analytical intelligence. They have an innate ability to analyze complex systems, produce long-term solutions, and design efficient software architectures.",
    strength: "Strength",
    weakness: "Weakness",
    deepAnalyticalThinking: "Deep Analytical Thinking",
    abilityToWorkIndependently: "Abitlity to Work Independently",
    strategicPlanning: "Strategic Planning",
    opennesToLearningAndDevelopment: "Openness to Learning and Development",
    dificultyInSocialComminications: "Difficulty in Social Communication",
    excessivePerfectionism: "Excessive Perfectionism",
    lackOfFlexibility: "Lack of Flexibility",
    dificultyAdaptingToTeamwork: "Difficult Adapting to Teamwork",
    mostPromissingFieldsForSuccess: "Most Promissing Fields for Sucsess",
    artificalIntelligenceandMachineLearning: "Artifical Inteligence and Machine Learning",
    dataScienceAndBigDataAnalytics: "Data Science and Big Data Analytics",
    blockchainAndCryptography: "Blockchain and Cryptography",
    cloudComputingAndDistributedSystems: "Cloud Computing and Distributed Systems",
    highPerformanceAlgorithmsAndSystemDesign: "High-Performance Algorithms and System Design",
    moreButton: "More...",

    
    //Contact Component
    contactMe: "Contact Me",
    messageMe: "Message me anytime! \nNew ideas or just a hello.",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    email: "Email",
    whatsapp: "WhatsApp",
    //Footer Component
    footerMessage: "~ Built with passion, powered by innovation ~",
    copyright: "© 2025 Ömer Yusuf Elmalı. All rights reserved.",
    



  },
  tr: {
    home: "Anasayfa",
    about: "Hakkında",
    skills: "Yetenekler",
    projects: "Projeler",
    contact: "İletişim",
    language: "Türkçe",
    switchLanguage: "English",
    //Hello Component
    hello: "Merhaba",
    myNameIs: "Benim adım",
    fullName: "ÖMER YUSUF ELMALI",
    //About Component
    aboutMe: "Hakkimda",
    personalInfoTitle: "Kişisel Bilgiler",
    experienceTitle: "Deneyim",
    educationTitle: "Eğitim",
    hobbiesTitle: "Hobiler",
    personalInfo: "Ben, Veri Mühendisliği ve Yapay Zeka konusunda tutkulu bir Bilgisayar Mühendisliği mezunuyum. Kariyer hedefim, bu alanlarda uzmanlaşmak ve dinamik ve yenilikçi bir ortamda sürekli olarak becerilerimi geliştirmektir. Şu anda, büyüyebileceğim ve heyecan verici projelere katkıda bulunabileceğim tam zamanlı bir pozisyon arıyorum. Gelecekte, cutting-edge ürünler yaratan bir takımda lider geliştirici olmayı hedefliyorum.",
    experience: "Çeşitli yapay zeka projelerinde çalıştım, bunlar arasında görüntü segmentasyonu, nesne tespiti ve mobil uygulamalar için derin öğrenme tabanlı modeller bulunmaktadır. Ayrıca, TensorFlow, PyTorch ve yapay zeka modellerinin üretim ortamlarında dağıtımı konusunda pratik deneyime sahibim.",
    education: "Bilgisayar Mühendisliği lisans diplomasına sahibim, eğitimim sırasında ağ yapıları ve Yapay Zeka üzerine yoğunlaştım. Ağ tasarımı, makine öğrenme algoritmaları ve bulut altyapısı konusunda uzmanlaştım. Ayrıca, tez çalışmamda derin pekiştirmeli öğrenme (DRL) kullanarak bir drone dengeleme projesi üzerinde çalıştım.",
    hobbies: "Koşmayı ve fiziksel sınırlarımı zorlamayı seviyorum. Yeni teknolojiler ve bulut altyapısı hakkında tutkuluyum, ayrıca kişisel projeler üzerinde çalışarak programlama ve yapay zeka becerilerimi sürekli geliştirmeye çalışıyorum.",
    //Skills Component
    mySkills:"Becerilerim",
    python: "Python",
    pythonDesc: "Genel amaçlı programlama dili",
    cpp: "C++",
    cppDesc: "Sistem ve performans programlama",
    bashScript: "Bash Script",
    bashScriptDesc: "Linux kabuk betikleri",
    sql: "SQL",
    sqlDesc: "Veritabanı sorgulama dili",
    firebase: "Firebase",
    firebaseDesc: "Backend hizmetleri ve gerçek zamanlı veritabanı",
    react: "React",
    reactDesc: "Arayüz geliştirme kütüphanesi",
    tailwind: "Tailwind CSS",
    tailwindDesc: "Yardımcı sınıflarla CSS framework",
    js: "JavaScript",
    jsDesc: "Web için programlama dili",
    tensorflow: "TensorFlow",
    tensorflowDesc: "Yapay zeka ve makine öğrenmesi framework'ü",
    pytorch: "PyTorch",
    pytorchDesc: "Derin öğrenme framework'ü",
    opencv: "OpenCV",
    opencvDesc: "Bilgisayarlı görü kütüphanesi",
    pandas: "Pandas",
    pandasDesc: "Veri analizi kütüphanesi",
    numpy: "NumPy",
    numpyDesc: "Bilimsel hesaplama kütüphanesi",
    fastapi: "FastAPI",
    fastapiDesc: "Hızlı API geliştirme framework'ü",
    flask: "Flask",
    flaskDesc: "Hafif web framework'ü",
    scikit: "Scikit-Learn",
    scikitDesc: "Makine öğrenmesi kütüphanesi",
    git: "Git",
    gitDesc: "Versiyon kontrol sistemi",
    docker: "Docker",
    dockerDesc: "Containerizasyon platformu",
    kubernetes: "Kubernetes",
    kubernetesDesc: "Container yönetim sistemi",
    linux: "Linux",
    linuxDesc: "İşletim sistemi ve kabuk betikleri",
    hadoop: "Apache Hadoop",
    hadoopDesc: "Büyük veri işleme framework'ü",
    hive: "Apache Hive",
    hiveDesc: "Veri ambarı sistemi",
    sqoop: "Apache Sqoop",
    sqoopDesc: "Büyük veri transfer aracı",
    kafka: "Apache Kafka",
    kafkaDesc: "Dağıtık olay akışı platformu",
    sqlserver: "Microsoft SQL Server",
    sqlserverDesc: "İlişkisel veritabanı sistemi",
    unreal: "Unreal Engine 4",
    unrealDesc: "Oyun geliştirme motoru",
    gazebo: "Gazebo",
    gazeboDesc: "Robotik simülasyon yazılımı",
    missionPlanner: "Mission Planner",
    missionPlannerDesc: "Otonom drone yazılımı",
    //My Project Component
    myProjects: "Projelerim",
    try: "Dene",
    robustDrone: "DAYANIKLI DRONE DENGELEME SİSTEMİ",
    robustDroneDesc: "Dört pervaneli bir drone için simüle edilmiş ortamda derin pekiştirmeli öğrenme algoritmaları kullanılarak dengeleme sistemi.",
    semanticClothes: "Giysiler Üzerinde Semantik Segmentasyon",
    semanticClothesDesc: "Giysi içeren bir fotoğrafı giriş olarak alır ve maskelenmiş ve kırpılmış çıktıyı üretir.",
    iso50001Chatbot: "ISO 50001 Bilgi Robotu",
    iso50001ChatbotDesc: "Enerji yönetim sistemi hakkında bilgi veren yapay zeka destekli chatbot uygulaması. ISO 50001 hakkında bilgilendirme yapar. ",
    //Personality Component
    personality: "Kisilik",
    personHead: "INTJ - Mimar",
    headLetter: "Mimarlar, yazılım geliştirme sürecinde analitik düşünme, uzun vadeli stratejiler oluşturma ve derin teknik bilgiyi birleştirme konusunda üstün yeteneklere sahiptir.",
    asASoftwareEngineer: "Yazılım Mühendisi Olarak INTJ",
    asASoftwareEngineerLetter: "INTJ’ler stratejik düşünme becerileri, problem çözme yetenekleri ve güçlü analitik zekaları ile yazılım mühendisliği alanında oldukça başarılı olurlar. Karmaşık sistemleri analiz etme, uzun vadeli çözümler üretme ve verimli yazılım mimarileri tasarlama konusunda doğuştan yeteneklidirler.",
    strength: "Güçlü Yönler",
    weakness: "Zayıf Yönler",
    deepAnalyticalThinking: "Derin Analitik Düşünme",
    abilityToWorkIndependently: "Bağımsız Çalışma Yeteneği",
    strategicPlanning: "Stratejik Planlama",
    opennesToLearningAndDevelopment: "Öğrenmeye ve Gelişime Açıklık",
    dificultyInSocialComminications: "Sosyal İletişimde Zorlanma",
    excessivePerfectionism: "Aşırı Mükemmeliyetçilik",
    lackOfFlexibility: "Esneklik Eksikliği",
    dificultyAdaptingToTeamwork: "Takım Çalışmasına Adaptasyon Zorlukları",
    mostPromissingFieldsForSuccess: "En Başarılı Olabilecek Alanlar",
    artificalIntelligenceandMachineLearning: "Yapay Zeka ve Makine Öğrenimi",
    dataScienceAndBigDataAnalytics: "Veri Bilimi ve Büyük Veri Analitiği",
    blockchainAndCryptography: "Blockchain ve Kriptografi",
    cloudComputingAndDistributedSystems: "Bulut Bilişim ve Dağıtık Sistemler",
    highPerformanceAlgorithmsAndSystemDesign: "Yüksek Performanslı Algoritmalar ve Sistem Tasarımı",
    moreButton: "Daha Fazlası...",
    //Contact Component
    contactMe: "Benimle Iletisime Gec",
    messageMe: "Her zaman mesaj atabilirsin!",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    email: "E-posta",
    whatsapp: "WhatsApp",
    //Footer Component
    footerMessage: "~ Tutkuyla inşa edildi, yenilikle güçlendirildi ~",
    copyright: "© 2025 Ömer Yusuf Elmalı. Tüm hakları saklıdır.",


  }
};
const en = translations.en;
const tr = translations.tr;

// `react-localization`'ı başlat
const languages = { en, tr };

// Localization Context oluştur
const LanguageContext = createContext();

export const LocalizationProvider = ({ children }) => {
  // localStorage'dan dil çek, yoksa varsayılan olarak "en" ayarla
  const [language, setLanguage] = useState(localStorage.getItem("language") || "en");

  useEffect(() => {
    localStorage.setItem("language", language); // Seçilen dili kaydet
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Kullanıcıya çevrilmiş metinleri sağlayan özel hook
export const useLocalizedStrings = () => {
  const { language } = useContext(LanguageContext);
  return languages[language]; // Seçili dile göre çeviri döndür
};

// Dil değiştirme fonksiyonunu sağlayan özel hook
export const useLanguage = () => {
  const { setLanguage } = useContext(LanguageContext);
  return setLanguage;
};